import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function About() {
  const navigate = useNavigate();
  
  const tmStyle = {
    fontSize: '0.5em',
    verticalAlign: 'super'
  };
  
  return (
    <div className="legal-page">
      <h1>About NeuLogic<span style={tmStyle}>™</span></h1>
      
      <section className="about-intro">
        <h2>Tools Built by One Person</h2>
        <p>
          NeuLogic<span style={tmStyle}>™</span> is me—one person building practical desktop tools that are fast, focused, and don't get in your way.
        </p>
        <p>
          After 25+ years in software quality assurance, I know what makes tools truly useful. I build software I wish existed, drawing from real problems I've encountered throughout my career.
        </p>
      </section>
      
      <section className="about-purpose">
        <h2>The Philosophy</h2>
        <p>
          I'm not a company with a roadmap or marketing team. I'm just someone who enjoys solving problems through code and tries to make things clean, useful, and respectful of your time.
        </p>
        <p>
          I keep some tools free, either because they didn't require as much development time or because I want to offer an alternative in spaces where free options already exist. I'm still figuring things out, but if something here helps you work better, that's the whole point.
        </p>
      </section>
      
      <section className="about-support">
        <h2>Support</h2>
        <p>
          For technical support or product inquiries, please email <a href="mailto:support@neulogic.tech">support@neulogic.tech</a>.
        </p>
      </section>
      
      <div className="productpage-actions productpage-actions-row" style={{justifyContent:'flex-start', marginTop:'80px'}}>
        <button className="card-btn productpage-btn-small" onClick={() => navigate('/')} type="button" style={{cursor:'pointer'}}>&larr; Home</button>
      </div>
    </div>
  );
}